// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CaretDown: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 7 5"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="7"
            height="5"
            fill="currentColor"
        >
            <path
                d="M218.673047,340.673047 L215.942383,343.423047 C215.789844,343.558398 215.613672,343.625 215.4375,343.625 C215.261328,343.625 215.085586,343.557861 214.951308,343.423584 L212.220644,340.673584 C212.004821,340.477539 211.945945,340.181055 212.052379,339.925391 C212.158812,339.669727 212.409707,339.5 212.6875,339.5 L218.168164,339.5 C218.446172,339.5 218.697109,339.66717 218.803671,339.924316 C218.910234,340.181463 218.870703,340.477539 218.673047,340.673047 L218.673047,340.673047 Z"
                transform="translate(-212 -339)"
            />
        </svg>
    );
};

export default React.memo(CaretDown);
